import React, { useCallback } from 'react';
import './ReadChapterInSeries.scss';
import ProductPoster from '../KodanshaUIKit/ProductPoster/ProductPoster';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { Comic } from '../../Models/Comic';
import { Product } from '../../Models/Product';
import { useHistory } from 'react-router-dom';
import { useWindowSize } from '../Hooks/useWindowSize';
import { readerReadableUrlOrDefault } from '../../utils/utils';

interface Props {
    chapterToRead: { type: 'Volume' | 'Chapter' | null; data: Product | Comic };
    preloadImage?: boolean;
}

const getReadingProgress = (chapterToRead) => {
    return (chapterToRead.data as Product)?.readable?.readingProgress === 0;
};

const ReadChapterInSeries = ({ chapterToRead, preloadImage }: Props): JSX.Element => {
    const history = useHistory();
    const { width } = useWindowSize();

    if (!chapterToRead.data) {
        return null;
    }

    const renderButton = useCallback((): JSX.Element => {
        return <KodanshaArrow text={getReadingProgress(chapterToRead) ? 'Read Now' : 'Resume'}
                              onClick={(): void => history.push(readerReadableUrlOrDefault(chapterToRead.data as Product), { returnPath: history.location.pathname })}
                              withArrow={true} invert={true} />;
    }, [chapterToRead]);

    function GetToReadString ():string {
        switch (chapterToRead.type){
            case 'Chapter':
                if ((chapterToRead.data as Product).relativeName !== undefined){
                    return (chapterToRead.data as Product).relativeName
                }
                return "Chapter " + chapterToRead.data?.chapterNumber
            case 'Volume':
                return "Volume " + chapterToRead.data.volumeNumber;
            default:
                return "Unsupported ChapterToReadType"
        }
    }

    return (
        <div className='read-in-series-column'>
            <div className='read-in-series-container'>
                <ProductPoster preloadImage={preloadImage} src={chapterToRead.data?.thumbnails[0].url}
                               alt={'Thumbnail for chapter ' + chapterToRead.data?.chapterNumber} ratio={120} />
                <div className='read-in-series-info-actions-wrapper'>
                    <div className='read-in-series-info-wrapper'>
                        <span className='read-in-series-header'>START READING</span>
                        <span
                            className='read-in-series-chapter'>{GetToReadString()}</span>
                        <span className='read-in-series-page'>
                    Page {(chapterToRead.data as Product)?.readable?.readingProgress + 1} / {(chapterToRead.data as Product)?.readable?.pageCount}
                </span>
                    </div>

                    {width >= 440 && renderButton()}
                </div>
            </div>

            {width < 440 && renderButton()}

        </div>
    );
};

export default ReadChapterInSeries;
